import { Component, ViewEncapsulation } from '@angular/core';
import { EheAnalyticsDirective } from '../shared/ehe-analytics/ehe-analytics.directive';
/** Registration Component */
@Component({
	templateUrl: './registration.component.html',
	styleUrls: ['./registration.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [EheAnalyticsDirective],
})
export class RegistrationComponent {}
